import { createSlice } from '@reduxjs/toolkit';

export const customCounsellingEightSlice = createSlice({
  name: 'customCounsellingEight',
  initialState: {
    allDataEight: null,
  },
  reducers: {
    setAllDataEight: (state, action) => {
      state.allDataEight = action.payload;
    },
  },
});

export const { setAllDataEight } = customCounsellingEightSlice.actions;
export default customCounsellingEightSlice.reducer;
